export const getParams = (props) => {
    return (
        props.history.location?.search
            .split('?')
            .slice(1)
            .map(i => i.split('=')[0])
    )
}